import {ChartApiWrapper} from "./ChartApiWrapper";
import "./charting.scss";
// import {CrosshairLinker} from "./CrosshairLinker";

var app = angular.module('tf.charting', [])
    .controller('chartingCtrl', ['$scope', '$location', '$uibModal', '$http', '$q', '$timeout', '$aside', '$localStorage', function chartingController($scope, $location, $uibModal, $http, $q, $timeout, $aside, $localStorage) {

        $scope.mainChartSymbol = null;

        // $scope.apiWrapper = new ChartApiWrapper();

        $scope.chartCreated = (api) => {
            $scope.apiWrapper.add(api)
        };

        $scope.chartRemoved = (id) => {
            $scope.apiWrapper.remove(id)
        };

        $scope.changeChartView = (isOpen) => {
            $scope.chartFull = !isOpen;
        };

        $scope.layoutSettings = {
            layout: $location.search().layout || $localStorage.chart_portal_layout || '1',
            crosshairsSynced: true
        };

        var layoutNo = +$scope.layoutSettings.layout;
        if(isNaN(layoutNo) || layoutNo <1 || layoutNo >10) {
            $scope.layoutSettings.layout = '1';
        }

        $location.search('layout', $scope.layoutSettings.layout);

        // $scope.linker = new CrosshairLinker(true);

        // $scope.chartOptions = { mainChartSymbol: $scope.symbol, crosshair: false, drawing: false, headsUp: null };

        $scope.asideState = {
            open: false
        };

        $scope.openLayoutModal = function () {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/apps/charting/widgets/chartingLayout.tpl.html',
                controller: 'chartingLayoutCtrl as chartingLayoutCtrl',
                size: 'sm',
                resolve: {
                    layoutSettings: $scope.layoutSettings
                }
            });
            modalInstance.result.then(function (layoutSettings) {
                Object.assign($scope.layoutSettings, layoutSettings);
                $localStorage.chart_portal_layout = $scope.layoutSettings.layout;
                $location.search('layout', $scope.layoutSettings.layout);
                // $scope.linker.setSync(layoutSettings.crosshairsSynced);
                $scope.apiWrapper.reset();
              });
        };

        $scope.changeMainChartSymbol = (code) => {
            $timeout(() => $scope.mainChartSymbol = code);
        }
    }])

    .controller('chartingLayoutCtrl', ['$scope', '$http', '$uibModalInstance', 'layoutSettings', function chartingLayoutController($scope, $http, $uibModalInstance, layoutSettings) {
        $scope.layoutSettings = Object.assign( {layout: "1"}, layoutSettings);

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.ok = function () {
            $uibModalInstance.close($scope.layoutSettings);
        };
        $scope.linkCodes = function () {
            $scope.layoutSettings.codesLinked = !$scope.layoutSettings.codesLinked;
        };

        $scope.syncCrosshair = function() {
            $scope.layoutSettings.crosshairsSynced = !$scope.layoutSettings.crosshairsSynced;
        };

        $scope.changeLayout = function($event) {
            $scope.layoutSettings.layout = $event.currentTarget.id.substr(7);  //lo-btn_10
        }
    }]);
